const initialState = { keys: {} };

// translations are included with initialState when creating the redux store
export default (state = initialState) => state;
